export function ConvSkeleton() {
  return (
    <div className="px-3 py-2 flex items-center gap-3 animate-pulse">
      <div className="w-10 h-10 bg-gray-200 rounded-full flex-shrink-0" />
      <div className="flex-1 space-y-2">
        <div className="flex justify-between">
          <div className="h-3.5 bg-gray-200 rounded w-28" />
          <div className="h-3 bg-gray-100 rounded w-10" />
        </div>
        <div className="h-3 bg-gray-100 rounded w-4/5" />
      </div>
    </div>
  );
}

export function MsgSkeleton({ mine }: { mine: boolean }) {
  return (
    <div className={`flex ${mine ? 'flex-row-reverse' : 'flex-row'} gap-2 mb-4 animate-pulse px-4`}>
      {!mine && <div className="w-8 h-8 bg-gray-200 rounded-full flex-shrink-0 mt-auto" />}
      <div className={`flex flex-col ${mine ? 'items-end' : 'items-start'} gap-1.5`}>
        <div className={`h-10 bg-gray-200 rounded-2xl ${mine ? 'w-44' : 'w-60'}`} />
        <div className="h-2.5 bg-gray-100 rounded w-12" />
      </div>
    </div>
  );
}
